import { useMemo } from 'react';
import { Combo } from '@/types';
import { colors } from '@/constants';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { RiExchange2Line } from 'react-icons/ri';
import { useSelectedClientScopeWithFallback, useTables } from '@/hooks';
import { isAfter, isBefore, isValid, parse, startOfDay } from 'date-fns';

const ComboContent = styled.div<{ $isList?: boolean }>`
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  padding: ${(i) => (i.$isList ? '4px 4px 4px 8px' : '4px')};
  border-radius: 6px;
  background-color: ${colors.alert.green200};
  color: ${colors.alert.green300};
  font-size: 11px;
  font-weight: 600;
  gap: 4px;
`;

export const ComboProduct = ({ COD_PRODUTO, direction }: { COD_PRODUTO: number, direction: 'grid' | 'list' }) => {
  const { tables } = useTables();
  const navigate = useNavigate();
  const selectedClientScope = useSelectedClientScopeWithFallback();

  const comboId = useMemo(() => {
    const combos = tables.current.combo;
    if (!combos?.length) return false;

    const filteredCombos = combos.filter((combo: Combo) => `${combo.cod_loja}` === `${selectedClientScope?.COD_LOJA}`);
    if (!filteredCombos?.length) return false;

    let comboId = '';

    const today = startOfDay(new Date());

    for (const combo of filteredCombos) {
      for (const comboItem of combo.combos) {
        if (comboItem.dt_fim) {
          const dtFim = parse(comboItem.dt_fim, 'dd/MM/yyyy', new Date());
          if (isValid(dtFim) && isAfter(today, startOfDay(dtFim))) continue;
        }

        if (comboItem.dt_inicio) {
          const dtInicio = parse(comboItem.dt_inicio, 'dd/MM/yyyy', new Date());
          if (isValid(dtInicio) && isBefore(today, startOfDay(dtInicio))) continue;
        }

        const isSkuElegivel = comboItem.grupos_exigencia.some((grupo => grupo.skus_elegiveis.some((sku => sku.cod_produto === `${COD_PRODUTO}`))));
        if (isSkuElegivel) {
          comboId = comboItem.id_campanha;
          break;
        }
      }
    }

    return comboId;
  }, [tables, selectedClientScope?.COD_LOJA]);

  const handleClick = () => {
    navigate(`/combos?id_campanha=${comboId}`);
  };

  return !!comboId && (
    <ComboContent $isList={direction === 'list'} onClick={handleClick}>
      {direction === 'list' && "Combos"}
      <RiExchange2Line size={16} />
    </ComboContent>
  );
};
